<!-- =========================================================================================
  File Name: TicketEdit.vue
  Description: Ticket Edit page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.button-wrap {
  text-align: right;
}
.header-custome{padding-left: 3px; margin-bottom: 15px;}
</style>
<template>
  <div id="page-ticket-add">
    <div class="header-custome">
      <h2>Edit Tickets</h2>
    </div>
    <vx-card v-if="ticket_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Ticket Info" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <ticket-edit-tab-info class="mt-4" :data="ticket_data" />
            </div>
          </vs-tab>
          
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import TicketEditTabInfo from "./TicketEditTabInfo.vue";

// Store Module
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";
import ls from "@/common/localStorage";
import moment from "moment-timezone";

let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
var vm;
export default {
  components: {
    TicketEditTabInfo
  },
  data() {
    return {
      ticket_data: null,
      ticket_not_found: false,
      
      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_ticket_data(this.$route.params.ticketId);
    }
  },
  methods: {    
    fetch_ticket_data(TicketId) {
      if (TicketId === undefined) {
        TicketId = null;
      }
      this.$store
        .dispatch("TicketManagement/fetchTicket", TicketId)
        .then(res => {
          this.ticket_data = res.data;
          this.ticket_data.SaleStartDate = this.SetTimeByZone(
            res.data.SaleStartDate,
            Session_Event_TZ
          );
          this.ticket_data.SaleEndDate = this.SetTimeByZone(
            res.data.SaleEndDate,
            Session_Event_TZ
          );
        })
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MM/DD/YYYY HH:mm");
      return date;
    },
  },
  created() {
    vm = this;
    //debugger;
    // Register Module TicketManagement Module
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule("TicketManagement", moduleTicketManagement);
      moduleTicketManagement.isRegistered = true;
    }
    this.fetch_ticket_data(this.$route.params.ticketId);
  }
};
</script>

